import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const tokenStore = {
  get access() {
    return localStorage.getItem("fp_access");
  },
  get refresh() {
    return localStorage.getItem("fp_refresh");
  },
  set(data) {
    if (data?.access_token) localStorage.setItem("fp_access", data.access_token);
    if (data?.refresh_token) localStorage.setItem("fp_refresh", data.refresh_token);
  },
  clear() {
    localStorage.removeItem("fp_access");
    localStorage.removeItem("fp_refresh");
  },
};

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = tokenStore.access;
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

const NO_REFRESH = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/mfa/verify", "/auth/google", "/auth/handoff"];
let refreshing = null;
const retryWith = (original, access) => {
  original.headers = original.headers || {};
  original.headers.Authorization = `Bearer ${access}`;
  return api(original);
};

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const used = tokenStore.refresh;
    const eligible = error.response?.status === 401 && original && !original._retry && used && !NO_REFRESH.some((p) => original.url?.includes(p));
    if (!eligible) return Promise.reject(error);
    original._retry = true;
    try {
      refreshing = refreshing || api.post("/auth/refresh", { refresh_token: used });
      const { data } = await refreshing;
      refreshing = null;
      tokenStore.set(data);
      return retryWith(original, data.access_token);
    } catch (e) {
      refreshing = null;
      if (tokenStore.refresh && tokenStore.refresh !== used) return retryWith(original, tokenStore.access);
      if (e.response?.status !== 409) tokenStore.clear();
      return Promise.reject(e);
    }
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const errorText = (e, fallback = "Something went wrong.") => formatApiError(e?.response?.data?.detail) || e?.message || fallback;
